// TODO: Update with official sports list from Champions Academy
export interface Sport {
  id: string;
  slug: string;
  name: {
    en: string;
    ar: string;
  };
  description: {
    en: string;
    ar: string;
  };
  image: string;
  ageGroups: (string | { range: string; name: { en: string; ar: string } })[];
  schedule: {
    en: string;
    ar: string;
  };
  coaches: number;
  gender?: { en: string; ar: string };
  branches?: { en: string; ar: string }[];
}

export const sports: Sport[] = [
  {
    id: "football",
    slug: "football",
    name: { en: "Football", ar: "كرة القدم" },
    description: {
      en: "Our flagship program with professional coaching and training facilities. Develop your skills with FIFA-certified coaches.",
      ar: "برنامجنا الرئيسي مع تدريب احترافي ومرافق تدريب متطورة. طور مهاراتك مع مدربين معتمدين من الفيفا."
    },
    image: "/img/sports/football.jpg",
    ageGroups: [
      { range: "4-6", name: { en: "Star Team", ar: "ستار تيم" } },
      { range: "7-8", name: { en: "Dream Team", ar: "دريم تيم" } },
      { range: "9-10", name: { en: "Golden Team", ar: "جولدن تيم" } },
      { range: "11-12", name: { en: "Challenge Team", ar: "تشالنج تيم" } },
      { range: "13-14", name: { en: "Future Team", ar: "فيوتشر تيم" } },
      { range: "14-16", name: { en: "Power Team", ar: "باور تيم" } }
    ],
    schedule: { en: "2 sessions per week", ar: "جلستين أسبوعياً" },
    coaches: 25
  },
  {
    id: "basketball",
    slug: "basketball",
    name: { en: "Basketball", ar: "كرة السلة" },
    description: {
      en: "Comprehensive basketball training program focusing on fundamentals, teamwork, and competitive skills. Open for males and females.",
      ar: "برنامج تدريب شامل لكرة السلة يركز على الأساسيات والعمل الجماعي والمهارات التنافسية. متاح للذكور والإناث."
    },
    image: "/img/sports/basketball.jpg",
    ageGroups: [
      { range: "6-7", name: { en: "Sun's", ar: "صنز" } },
      { range: "8-9", name: { en: "Boys", ar: "بويز" } },
      { range: "10-11", name: { en: "Flowers", ar: "فلاورز" } },
      { range: "12-13", name: { en: "Unicorns", ar: "يونيكورنز" } },
      { range: "14-15", name: { en: "Moons", ar: "مونز" } },
      { range: "16-17", name: { en: "Stars", ar: "ستارز" } }
    ],
    schedule: { en: "2 sessions per week", ar: "جلستين أسبوعياً" },
    coaches: 6,
    gender: { en: "Males & Females", ar: "ذكور وإناث" },
    branches: [{ en: "Gaza City", ar: "محافظة غزة" }]
  },
  {
    id: "swimming",
    slug: "swimming",
    name: { en: "Swimming", ar: "السباحة" },
    description: {
      en: "Olympic-standard swimming program with certified instructors. All skill levels welcome.",
      ar: "برنامج سباحة بمعايير أولمبية مع مدربين معتمدين. جميع المستويات مرحب بها."
    },
    image: "/img/sports/swimming.jpg",
    ageGroups: ["4-6", "7-10", "11-15", "16+"],
    schedule: { en: "2 sessions per week", ar: "جلستين أسبوعياً" },
    coaches: 15,
    gender: { en: "Males & Females", ar: "مدربين ومدربات" },
    branches: [
      { en: "Gaza City", ar: "محافظة غزة - مدينة غزة" },
      { en: "Nuseirat, Central Gaza", ar: "محافظة الوسطى - مدينة النصيرات" },
      { en: "Khan Younis, South Gaza", ar: "محافظة الجنوب - مدينة خان يونس" }
    ]
  },
  {
    id: "dabke",
    slug: "dabke",
    name: { en: "Dabke", ar: "الدبكة" },
    description: {
      en: "Traditional Palestinian Dabke dance training that celebrates our cultural heritage. Build fitness, coordination, and community spirit. Open for males and females.",
      ar: "تدريب رقص الدبكة الفلسطينية التقليدية الذي يحتفي بتراثنا الثقافي. بناء اللياقة والتنسيق وروح المجتمع. متاح للذكور والإناث."
    },
    image: "/placeholder.svg",
    ageGroups: [
      { range: "6-8", name: { en: "Mejana", ar: "ميجنا" } },
      { range: "9-11", name: { en: "Mili", ar: "ميلي" } },
      { range: "12-14", name: { en: "Zareef El-Tool", ar: "زريف الطول" } },
      { range: "15-17", name: { en: "Jafra", ar: "جفرا" } },
      { range: "18+", name: { en: "Dal'ouna", ar: "دلعونا" } }
    ],
    schedule: { en: "2 sessions per week", ar: "جلستين أسبوعياً" },
    coaches: 4,
    gender: { en: "Males & Females", ar: "ذكور وإناث" },
    branches: [{ en: "Gaza City", ar: "محافظة غزة" }]
  },
  {
    id: "tennis",
    slug: "tennis",
    name: { en: "Ground Tennis", ar: "التنس الأرضي" },
    description: {
      en: "Professional ground tennis coaching on world-class courts. Individual and group sessions available. Starting from age 6.",
      ar: "تدريب تنس أرضي احترافي على ملاعب عالمية المستوى. جلسات فردية وجماعية متاحة. تبدأ من عمر 6 سنوات."
    },
    image: "/img/sports/tennis.jpg",
    ageGroups: ["6-8", "9-12", "13-17", "18+"],
    schedule: { en: "2 sessions per week", ar: "جلستين أسبوعياً" },
    coaches: 2,
    branches: [{ en: "Gaza City", ar: "محافظة غزة - مدينة غزة" }]
  },
  {
    id: "karate",
    slug: "karate",
    name: { en: "Karate", ar: "الكاراتيه" },
    description: {
      en: "Traditional karate training with certified black belt instructors. Focus on discipline, respect, and self-defense. Ages 4-16.",
      ar: "تدريب كاراتيه تقليدي مع مدربين حاصلين على الحزام الأسود. التركيز على الانضباط والاحترام والدفاع عن النفس. من 4 حتى 16 عام."
    },
    image: "/img/sports/karate.jpg",
    ageGroups: ["4-6", "7-9", "10-12", "13-16"],
    schedule: { en: "2 sessions per week", ar: "جلستين أسبوعياً" },
    coaches: 7,
    branches: [
      { en: "Gaza City", ar: "محافظة غزة - مدينة غزة" },
      { en: "Nuseirat, Central Gaza", ar: "محافظة الوسطى - النصيرات" },
      { en: "Khan Younis, South Gaza", ar: "محافظة الجنوب - خان يونس" }
    ]
  },
  {
    id: "table-tennis",
    slug: "table-tennis",
    name: { en: "Table Tennis", ar: "تنس الطاولة" },
    description: {
      en: "Fast-paced table tennis training for all skill levels. Improve reflexes, focus, and hand-eye coordination.",
      ar: "تدريب تنس طاولة سريع الإيقاع لجميع المستويات. تحسين ردود الفعل والتركيز والتنسيق بين العين واليد."
    },
    image: "/img/sports/table-tennis.jpg",
    ageGroups: ["6-10", "11-15", "16+"],
    schedule: { en: "2 sessions per week", ar: "جلستين أسبوعياً" },
    coaches: 6,
    branches: [{ en: "Gaza City", ar: "محافظة غزة - مدينة غزة" }]
  },
  {
    id: "squash",
    slug: "squash",
    name: { en: "Squash", ar: "الاسكواش" },
    description: {
      en: "High-intensity squash training on professional courts. Build endurance, speed, and strategic thinking. Open for males and females. Ages 6-16.",
      ar: "تدريب اسكواش عالي الكثافة على ملاعب احترافية. بناء التحمل والسرعة والتفكير الاستراتيجي. متاح للذكور والإناث. من 6 حتى 16 عام."
    },
    image: "/img/sports/squash.jpg",
    ageGroups: ["6-8", "9-12", "13-16"],
    schedule: { en: "2 sessions per week", ar: "جلستين أسبوعياً" },
    coaches: 3,
    gender: { en: "Males & Females", ar: "ذكور وإناث" },
    branches: [{ en: "Gaza City", ar: "محافظة غزة" }]
  }
];
